import {
  Box,
  Button,
  CircularProgress,
  Modal,
  SxProps,
  Typography,
} from "@mui/material";
import {
  ModalActionButtonStyles,
  ModalBaseStyles,
  ModalHeader,
} from "../../Common/styles/modal";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import { useParams } from "react-router-dom";
import { ChangeEvent, useState } from "react";
import { useAppDispatch } from "../../../Redux/hooks";
import { setStateToggle } from "../../../Redux/reducers/studySlice";
import UploadIcon from "@mui/icons-material/Upload";

type Props = {
  showModal: boolean;
  closeModal: () => void;
};

const ImportDataDictionaryModal = ({ showModal, closeModal }: Props) => {
  const dispatch = useAppDispatch();
  const [submitLoader, setSubmitLoader] = useState(false);
  const { id: studyId } = useParams();

  const submitHandler = async (e: ChangeEvent<HTMLInputElement>) => {
    try {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          toastMessage("warning", "File size must smaller than 5MB!");
          return false;
        }
        const formData = new FormData();
        formData.append("file", file);
        setSubmitLoader(true);
        let res = await http.post(
          `/study/${studyId}/data-dictionary/import?type=redcap&fileType=csv`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        toastMessage("success", res.data.message);
        closeModal();
        setSubmitLoader(false);
        dispatch(setStateToggle());
      }
    } catch (err) {
      setSubmitLoader(false);
      errorToastMessage(err as Error);
    }
  };

  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader title={"Data Dictionary"} onCloseClick={closeModal} />
        <Box>
          <Typography variant="h3" color="text.primary" mb={2}>
            Upload Data Dictionary in CSV format from Redcap
          </Typography>
          {submitLoader ? (
            <CircularProgress size={25} />
          ) : (
            <Button
              variant="contained"
              component="label"
              startIcon={<UploadIcon />}
              sx={{ mr: 2 }}
            >
              <span>Upload File</span>
              <input
                hidden
                accept="text/xml, application/xml, application/xhtml+xml"
                type="file"
                onChange={submitHandler}
              />
            </Button>
          )}
        </Box>

        <Box sx={{ ...ModalActionButtonStyles, mt: 2 }}>
          <Button onClick={closeModal} variant="outlined">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ImportDataDictionaryModal;
